import { createSlice } from "@reduxjs/toolkit";

const destinosState = {
  destinosdata: {},
};

const destinosSlice = createSlice({
  name: "destinos",
  initialState: destinosState,
  reducers: {
    destinosData: (state, actions) => actions.payload,
    limpiarDestinosData: () => destinosState,
  },
});

export const { destinosData, limpiarDestinosData } = destinosSlice.actions;

export default destinosSlice.reducer;